"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.find");

var _Mask2 = _interopRequireDefault(require("../Mask"));

require("./index.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * 弹框，继承Mask，请参考mask的参数及方法
 * 参数：
 *  {
 *    footer：{String} 底部按钮，如<div class="cancel">取消</div><div class="confirm">确认</div>
 *    animation：{Boolean} 是否适用显示动画，pop效果，默认true
 *  }
 *  方法：
 *    update：
 *      入参：
 *        {
 *          body：{String} 内容
 *          footer：{String} 底部按钮
 *        }
 */
var Modal =
/*#__PURE__*/
function (_Mask) {
  _inherits(Modal, _Mask);

  function Modal(_opts) {
    _classCallCheck(this, Modal);

    var def = {
      cls: '',
      body: '',
      footer: '',
      animation: true
    };

    var opts = _objectSpread({}, def, _opts);

    opts.cls = "tinker-modal ".concat(opts.cls);
    opts.body = "<div class=\"modal-body\">".concat(opts.body, "</div><div class=\"modal-footer\">").concat(opts.footer, "</div>");
    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, opts));
  }

  _createClass(Modal, [{
    key: "_init",
    value: function _init() {
      _get(_getPrototypeOf(Modal.prototype), "_init", this).call(this);

      if (this.opts.animation) {
        this.DK.find('.body').addClass('body-pop');
      }
    }
  }, {
    key: "update",
    value: function update() {
      var body = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var footer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      body !== null && this.DK.find('.modal-body').html(body);
      footer !== null && this.DK.find('.modal-footer').html(body);
      return this;
    }
  }]);

  return Modal;
}(_Mask2.default);

exports.default = Modal;